import _ from 'lodash'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { IAppDidMountHandler, IAppWillMountHandler, IPropsStore, Props } from '@wix/thunderbolt-symbols'
import { IWarmupDataProvider, WarmupDataProviderSymbol } from 'feature-warmup-data'
import { OOIWarmupData } from '../types'

export default withDependencies<IAppWillMountHandler & IAppDidMountHandler>(
	[WarmupDataProviderSymbol, Props],
	(warmupDataProvider: IWarmupDataProvider, props: IPropsStore) => ({
		appWillMount: async () => {
			const ooiWarmupData = await warmupDataProvider.getWarmupData<OOIWarmupData>('ooi')
			_.forEach(ooiWarmupData?.failedInSsr, (__, compId) => {
				props.update({
					[compId]: {
						__VIEWER_INTERNAL: {
							failedInSsr: true,
						},
					},
				})
			})
		},
		appDidMount: async () => {
			const ooiWarmupData = await warmupDataProvider.getWarmupData<OOIWarmupData>('ooi')
			_.forEach(ooiWarmupData?.failedInSsr, (__, compId) => {
				props.update({
					[compId]: {
						__VIEWER_INTERNAL: {},
					},
				})
			})
		},
	})
)
